import React from 'react'
import { useLocalVideo } from 'amazon-chime-sdk-component-library-react'
import Fab from '@mui/material/Fab'
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined'
import VideocamOffOutlinedIcon from '@mui/icons-material/VideocamOffOutlined'

import ControlBarItem from './ControlBarItem'

type VideoInputControlProps = { }

export default function VideoInputControl(props: VideoInputControlProps) {
  const { isVideoEnabled, toggleVideo } = useLocalVideo()

  return (
    <ControlBarItem>
      <Fab color="primary" onClick={toggleVideo} size="small">
        {isVideoEnabled ? <VideocamOutlinedIcon /> : <VideocamOffOutlinedIcon />}
      </Fab>
    </ControlBarItem>
  )
}